import Errors from '../classes/Errors';
import { ErrorWrapper } from '@/services/util.js';

export default {
  data: () => ({
    errors: new Errors()
  }),

  methods: {
    handleErrorsByResponse({ status, data }) {
      if (status === 422) {
        this.errors.record(data.errors);
      }
    },

    handleErrors(data) {
      if (data instanceof ErrorWrapper) {
        if (data.status === 422) {
          this.errors.record(data.errors);
        }
      }
    },

    clearErrorByName(fieldName, prefix) {
      if (!fieldName) {
        return;
      }

      this.errors.clear(prefix ? `${prefix}.${fieldName}` : fieldName);
    },

    clearErrorByEvent(event, prefix) {
      if (!event || !event.target) {
        return;
      }

      this.clearErrorByName(event.target.name, prefix);
    }
  }
};
